import './home.css'
import Section from "../components/homeSection"
import ButtonSection from "../components/infoCenterTool";

export default function Home() {
  return (
    <section className="home-div">
      <Section 
        image="/images/mikeSmith.jpg"
        title=""
        text={[
          "We believe in the value of relationships. We view every client relationship like a partnership, and we truly believe that our success is a result of your success.",
          "We are committed to providing close, personal attention to our clients. We take pride in giving you the assurance that the assistance you receive comes from years of advanced training, technical experience and financial acumen.",
          "Our continual investment of time and resources in professional continuing education, computer technology and extensive business relationships is indicative of our commitment to excellence."
        ]}
      />

      <h2> Client Portal</h2>
      <p style={{textAlign: 'center'}}>
        We are always looking for ways to make sharing information with us easier and more secure.
      </p>

      <ButtonSection 
        button="portal"
        title="The Client Portal allows you to:"
        text={[
          "Access documents anytime.",
          "Upload, send, and receive documents securely.",
          "Sign documents electronically."
        ]}
      />


      <p style={{textAlign: 'center'}}>
        Register for our secure Client Portal by contacting{" "}
        <a href="mailto:lizz@msmithaccounting.ca" style={{color: "#2f7d32"}}>
          lizz@msmithaccounting.ca
        </a>
      </p>

      <h2 style={{paddingTop: '20px'}}>Client Tax Organizer</h2>

      <ButtonSection 
        button="organizer"
        title=""
        text={["A tax organizer can facilitate the process of pulling together your tax information. This basic tax organizer is designed for new clients and allows you to enter your information right on the screen. You can then print the completed tax organizer and fax or mail it to the office."]}
      />
    </section>
  );
}



